import React, { useState, useEffect } from "react"
import _ from "lodash"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NamedItemInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const CommissionBasic = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    amtType: null,
    inflationNamedItemId: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (field === 'amtType' && (val === '% of Rent Paid' || val === '# of Mos Rent')){
      nextData['inflationNamedItemId'] = null
    }
    if (!nextData['amtType']) nextData['amtType'] = props.defaults['commissionAmtType']
    if (!nextData['inflationNamedItemId'] && props.defaults['commissionInflation']) nextData['inflationNamedItemId'] = props.defaults['commissionInflation']['inflationNamedItemId']
    const clearInflation = ['% of Rent Paid', '# of Mos Rent'].includes(field == 'amtType' ? val : _.get(nextData, 'amtType'))
    if (clearInflation) _.set(nextData, 'inflationNamedItemId', null)
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'commissiondetail', props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="amt" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Amt Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="amtType" options={['Amt/Area', 'Amt/Unit', '% of Rent Paid', '# of Mos Rent']} persist={updateData} default={props.defaults['commissionAmtType']} />
        </div>
        <div>
          <label>Inflation</label>
          <NamedItemInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field="inflationNamedItemId" 
            options={props.namedItems['inflation']} 
            namedItem="inflationid"
            persist={updateData} disabled={data && (data['amtType'] === '% of Rent Paid' || data['amtType'] === '# of Mos Rent')} 
            default={props.defaults['commissionInflation'] && props.defaults['commissionInflation']['inflationNamedItemId']} 
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default CommissionBasic